import BlogArticleLayout from '../../components/BlogArticleLayout';
import BlogImage from '../../assets/blogs/How to Build a High-Converting Website in 2024-2.jpg';

export default function WhyYourBusinessWebsite() {
  return (
    <BlogArticleLayout
      title="Why Your Business Website Is Costing You Customers (And How to Fix It)"
      image={BlogImage}
      imageAlt="Business website performance issues"
      ctaLabel="Book a free website audit"
    >
      <p>
        Your website is often the first impression your business makes—and sometimes, it’s the only one you get. If
        your site isn’t performing at its best, you could be silently losing potential customers every single day.
      </p>

      <h2 className="text-2xl font-semibold text-slate-900">1. Slow load times</h2>
      <p>
        Today’s users are impatient. If your site takes more than a few seconds to load, most visitors will leave before
        they even see your content. Slow websites not only kill conversions, but they also hurt your search rankings.
      </p>
      <p>
        <strong>What to do:</strong> Compress images, eliminate unnecessary code, use caching, and upgrade to faster
        hosting. At Anorc Inc, we build performance-optimized websites that load fast and rank high.
      </p>

      <h2 className="text-2xl font-semibold text-slate-900">2. Outdated or cluttered design</h2>
      <p>
        An old-school or overly busy website design creates distrust. Visitors associate design with credibility. If
        your site looks like it hasn’t been updated in years, they may assume your business hasn’t either.
      </p>
      <p>
        <strong>What to do:</strong> Use a clean, modern layout with intuitive navigation. Stick to a consistent color
        palette, use high-quality images, and align your design with your brand identity.
      </p>

      <h2 className="text-2xl font-semibold text-slate-900">3. Poor mobile experience</h2>
      <p>
        More than half of all website traffic comes from mobile devices. If your site doesn’t function properly on
        smartphones or tablets, you’re shutting the door on a massive chunk of your audience.
      </p>
      <p>
        <strong>What to do:</strong> Make your website responsive across all screen sizes. We ensure every site we build
        at Anorc Inc looks and works great on mobile, tablet, and desktop.
      </p>

      <h2 className="text-2xl font-semibold text-slate-900">4. No clear call to action</h2>
      <p>
        Even if your site gets traffic, it won’t convert if users don’t know what to do next. Whether it’s buying a
        product, booking a call, or requesting a quote—your CTA needs to guide the visitor clearly.
      </p>
      <p>
        <strong>What to do:</strong> Add visible, action-driven CTAs throughout your site. Examples include “Schedule a
        Free Consultation,” “Start Your Project,” or “Request a Quote.”
      </p>

      <h2 className="text-2xl font-semibold text-slate-900">5. Unclear messaging</h2>
      <p>
        If users land on your site and don’t immediately understand what you offer, they’ll leave. Confusing language,
        vague headlines, or industry jargon can all lead to lost opportunities.
      </p>
      <p>
        <strong>What to do:</strong> Use simple, benefit-focused messaging. Speak directly to your audience’s pain
        points and explain how your service solves them.
      </p>

      <h2 className="text-2xl font-semibold text-slate-900">Final thoughts</h2>
      <p>
        Your website should be your best salesperson—working 24/7 to attract, inform, and convert visitors. If it’s not
        doing that, it’s time for a change. At <strong>Anorc Inc</strong>, we specialise in building high-performing,
        conversion-focused websites for small and medium-sized businesses. Whether you’re starting from scratch or ready
        for a redesign, we can help you turn your website into a growth machine.
      </p>
    </BlogArticleLayout>
  );
}
